<template>
  <div id="dashboardLogistics">

    <div class="headerContent">
      <div class="headerRight">
        {{ timeInfo.currentTime }}&nbsp; {{ timeInfo.date }} &nbsp;{{ timeInfo.weekday }}
      </div>
      <div class="headerMiddle">
        上海市静安区市北高新无人机物流管理平台
      </div>

    </div>
    <div class="headerLeft">
      <div class="headerBtn" style="margin-right: 12px" @click="()=>{this.$router.push({path:'/index'})}">返回</div>
    </div>
    <div class="mapWrap" >
      <!--      <iframe  src="../../../static/LacmisNJ/logistics.html" width="100%" height="100%;"></iframe>-->
      <map2d @update-realTask="updateRealTask" :isRequestPlanDetail="true" actionScope="logistics" @update-PlanPont="updatePlanPont"></map2d>
    </div>
    <div class="contentWrap">
      <div class="leftContent">
        <!--        <div class="contentItem">-->
        <div class="contentItem68" >
          <div class="itemTitle">
            <div class="itemTitleText">飞行活动</div>
          </div>
          <div class="taskcontent_2d" >
            <div class="taskSearchBox" >
              <el-input
                placeholder="飞机型号,驾驶员,执照号,运营人,备注"
                v-model="searchTaskKeyWord "
                @keyup.enter.native="searchClick"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
              </el-input>
            </div>

            <div class="listAll_2d" v-if="taskList.length !== 0">
              <div
                class="task-item_2d"
                v-for="item in taskList"
                :key="item.id"
                :title="'飞机号:'+item.uavSerial"
                @click="positPlane(item)"
              >
                <div class="donePlan common" v-if="item.status==13||item.status==14">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #ee3f3f">已执行</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="executePlan common" v-if="item.status==10||item.status==11||item.status==12">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00ffff">执行中</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="prePlan common" v-if="item.status==0||item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==7||item.status==8||item.status==9">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00aeff">待执行</div>
                  <div class="itemDetail"></div>
                </div>

              </div>
            </div>
            <div class="emptyWrap" v-if="taskList.length == 0">
              <Empty/>
            </div>
          </div>
          <!--          <div class="plan">-->
          <!--            <div class="one">-->
          <!--              <div class="alarmState1">-->
          <!--                <div class="numbers">-->
          <!--                  <div class="num">20</div>-->
          <!--                  <div class="span">次</div>-->
          <!--                </div>-->
          <!--                <div class="txts">起降场冲突</div>-->
          <!--              </div>-->
          <!--              <div class="alarmState2">-->
          <!--                <div class="numbers">-->
          <!--                  <div class="num">20</div>-->
          <!--                  <div class="span">次</div>-->
          <!--                </div>-->
          <!--                <div class="txts">空域侵入</div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="one">-->
          <!--              <div class="alarmState3">-->
          <!--                <div class="numbers">-->
          <!--                  <div class="num">20</div>-->
          <!--                  <div class="span">次</div>-->
          <!--                </div>-->
          <!--                <div class="txts">目标超速</div>-->
          <!--              </div>-->
          <!--              <div class="alarmState4">-->
          <!--                <div class="numbers">-->
          <!--                  <div class="num">20</div>-->
          <!--                  <div class="span">次</div>-->
          <!--                </div>-->
          <!--                <div class="txts">短期冲突</div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <!--        <div class="contentItem30">-->
        <!--          <div class="itemTitle">-->
        <!--            <div class="itemTitleText">执行中计划</div>-->
        <!--          </div>-->
        <!--          <div class="taskcontent_2d">-->
        <!--            <div class="taskSearchBox" >-->
        <!--              <el-input-->
        <!--                placeholder="请输入..."-->
        <!--                v-model="searchRealTask "-->
        <!--                @keyup.enter.native="searchClick(3)"-->
        <!--              >-->
        <!--                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick(3)"></i>-->
        <!--              </el-input>-->
        <!--            </div>-->

        <!--            <div class="listAll_2d"  v-if="changeRunTask.length!==0">-->
        <!--              <div-->
        <!--                class="task-item_2d executePlan"-->
        <!--                style="background: #2f1d0b;"-->
        <!--                v-for="item in changeRunTask"-->
        <!--                :key="item.id"-->
        <!--                @click="positPlane(item)"-->
        <!--              >-->
        <!--                <div class="firstSpan" style="color: #ffc877;">{{ item.planSerial }}</div>-->
        <!--                <div class="secondSpan" style="color: #ffc877;">{{ item.pilot }}</div>-->
        <!--                <div class="thirdSpan" style="color: #ffc877;">-->
        <!--                  {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ? '物流' : item.type == 3 ?'应急':'物流' }}-->
        <!--                </div>-->
        <!--                <div class="planeBtns">-->
        <!--                  <div class="planTobtn" @click.stop="clickStart(item)">-->
        <!--                    <img-->
        <!--                      src="../../assets/img/2dmap/qifei.png"-->
        <!--                      alt=""-->
        <!--                    />-->
        <!--                    <span>起飞</span>-->
        <!--                  </div>-->
        <!--                  <div class="planTobtn" @click.stop="clickCircle(item)">-->
        <!--                    <img-->
        <!--                      v-if="changeIds.includes(item.id)"-->
        <!--                      src="../../assets/img/2dmap/panxuan_click.png"-->
        <!--                      alt=""-->
        <!--                    />-->
        <!--                    <img-->
        <!--                      v-if="!changeIds.includes(item.id)"-->
        <!--                      src="../../assets/img/2dmap/panxuan.png"-->
        <!--                      alt=""-->
        <!--                    />-->
        <!--                    <span>{{!changeIds.includes(item.id)?'悬停':'恢复'}}</span>-->
        <!--                  </div>-->
        <!--                  <div class="planTobtn "  disabled @click.stop="clickDown(item)">-->
        <!--                    <img-->
        <!--                      src="../../assets/img/2dmap/jiangluo.png"-->
        <!--                      alt=""-->
        <!--                    />-->
        <!--                    <span>降落</span>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="emptyContent" v-if="changeRunTask.length===0">-->
        <!--              <span>暂无数据</span>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->
        <!--&lt;!&ndash;        <div class="contentItem">&ndash;&gt;-->
        <!--        <div class="contentItem30">-->
        <!--          <div class="itemTitle">-->
        <!--            <div class="itemTitleText">待执行计划</div>-->
        <!--          </div>-->
        <!--          <div class="taskcontent_2d">-->
        <!--            <div class="taskSearchBox" >-->
        <!--              <el-input-->
        <!--                placeholder="请输入..."-->
        <!--                v-model="searchPreTask "-->
        <!--                @keyup.enter.native="searchClick(2)"-->
        <!--              >-->
        <!--                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick(2)"></i>-->
        <!--              </el-input>-->
        <!--            </div>-->

        <!--            <div class="listAll_2d" v-if="preTask.length !== 0">-->
        <!--              <div class="task-list">-->
        <!--                <div-->
        <!--                  class="task-item_2d prePlan"-->
        <!--                  style="background: #2d0a0a;"-->
        <!--                  v-for="item in preTask"-->
        <!--                  :key="item.id"-->
        <!--                  @click="positPlane(item)"-->
        <!--                >-->
        <!--                  <div class="firstSpan" style="color: red;">{{ item.planSerial }}</div>-->
        <!--                  <div class="secondSpan" style="color: red;">{{ item.pilot }}</div>-->
        <!--                  <div class="thirdSpan lastItem" style="color: red;">-->
        <!--                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="emptyContent" v-if="preTask.length == 0">-->
        <!--              <span>暂无数据</span>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="contentItem">-->
        <div class="contentItem32">
          <div class="itemTitle">
            <div class="itemTitleText">实时事件</div>
          </div>
          <div class="taskWrap">
            <div class="taskcontent_2d realTask" >
              <div class="listAll_2d"  style="height: 100% ;overflow: auto" v-if="realTask.length !== 0">
                <div
                  class="task-item_2d_realTask"
                  :class="item.warning ? 'warn_2d' : 'alarm_2d'"
                  v-for="item in realTask"
                >
                  <div class="firstSpan">{{ item.warnMes }}</div>
                </div>

              </div>
              <Empty v-if="realTask.length == 0" :width="320" :height="260" ></Empty>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="infoPanel" v-show="isDetailOpen">
          <planDetail :clickPlaneInfo="clickPlaneInfo" :planeDetailData="planeDetailData" :isDetailOpen="isDetailOpen"
                      :planeChartData="planeChartData"
                      :changeDetailOpen="changeDetailOpen">
          </planDetail>
        </div>
      </div>

    </div>
    <PlanInfo :taskForm="taskForm" :clickButton="clickButton"   @update:dialogVisible="updateDialogVisible" @closeForm="closeForm"
    ></PlanInfo>
  </div>
</template>

<script >
import echarts from "echarts";
import planDetail from './components/PlanDetail.vue'
import map2d from './components/map2d.vue'
import PlanInfo from "../../common/PlanDetail.vue";
import Empty from "../../common/Empty.vue";
export default {
  name: "logistics",
  data() {
    return {
      taskForm:{},
      clickButton:false,
      realTask:[],
      searchTaskKeyWord:'',
      taskList:[],
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      realTask1:[
        {warning:1,warnMes:'2024年11月30日14:35分FC30发生偏航预警2024年11月30日14:38分FC30发生偏航告警2024年11月30日14:38分FC30发生偏航告警2024年11月30日14:38分FC30发生偏航告警'},
        {warning:0,warnMes:'2024年11月30日14:38分FC30发生偏航告警'},
        {warning:1,warnMes:'2024年12月2日15:28分FC30发生偏航预警'},
        {warning:1,warnMes:'2024年12月2日15:29分M3TD发生偏航预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
      ],
      clickPlane:null,
      planeChartData: [],//飞机高度速度曲线数据
      planeDetailData: {},//飞机详情数据
      clickPlaneInfo: {},//显示实时飞行的飞机详情
      alarmInfo:[
        {
          id:'791660745',
          content:'任务超时!',
          state:'已解决'
        },
        {
          id:'791607440',
          content:'与前机距离小于50m!',
          state:'警告'
        },
        {
          id:'791607413',
          content:'运输偏离航道!',
          state:'已解决'
        },
        {
          id:'791607450',
          content:'运输偏离航道!',
          state:'已解决'
        }
      ],
      leftTop:null,
      leftTopData:[],
      isDetailOpen:true,
      chartTimer:null,//chart定时器
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      changeRunTask: [], //处理后的计划
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',
      startIds:[],
      changeIds:[],
      downIds:[],
      infoArr:[]
    };
  },
  components:{
    map2d,
    planDetail,
    PlanInfo,
    Empty
  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    }
  },
  mounted() {
    // this.getPlaneDetailData("1581F7C6B24A8001X5MH",1732678421)
    // this.getChartData("1581F7C6B24A8001X5MH")
    // this.chartTimer = setInterval(()=>{
    //   // this.getPlaneDetailData("1581F7C6B24A8001X5MH",1732678421)
    //   this.getChartData("1581F7C6B24A8001X5MH")
    // },10000)
    this.setTime();
    this.getPageData()
    this.queryPlan()
    window.queryTaskTimer = setInterval(this.queryPlan, 10000);
    window.addEventListener('resize', this.handleResize, {passive: true});
    window.timer = setInterval(this.setTime, 1000);
  },
  beforeDestroy() {
    // clearInterval(this.chartTimer);
    // this.chartTimer = null
    clearInterval(window.queryTaskTimer)
    clearInterval(window.timer)

  },
  methods: {
    showPlanDetail(info){
      console.log(info)
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    updateRealTask(v){
      if(v&&v.length){
        this.realTask = v
      }

    },
    //更新飞机点位信息
    updatePlanPont(v){
      v.clickPlaneInfo?this.clickPlaneInfo=v.clickPlaneInfo:''
      v.planeDetailData?this.planeDetailData=v.planeDetailData:''
      v.planeChartData?this.planeChartData=v.planeChartData:''
    },
    //获取飞机详细信息
    // getPlaneDetailData(uasId, planNo) {
    //   this.getRequest(
    //     `/uav-task-server/plandto/getAircraftDetail?orderID=${planNo}&uavSerial=${uasId}`
    //   ).then(res => {
    //     let oData = res.data;
    //     if (oData.code == 0) {
    //       this.planeDetailData = oData.data
    //     } else {
    //       this.$message.error({
    //         message: oData.msg,
    //         duration: 1000,
    //         customClass: "message-warn-s",
    //         iconClass: "el-icon-warn-tip",
    //         offset: 470,
    //         onClose: function () {
    //         },
    //       });
    //     }
    //   });
    // },
    //获取飞机速度高度曲线数据
    // getChartData(uasId) {
    //   this.getRequest(
    //     `/uav-task-server/point/getGsAltitudeTimeCurve?uasID=${uasId}`
    //   ).then(res => {
    //     let oData = res.data;
    //     if (oData.code == 0) {
    //       this.planeChartData = oData.data
    //     } else {
    //       this.$message.error({
    //         message: oData.msg,
    //         duration: 1000,
    //         customClass: "message-warn-s",
    //         iconClass: "el-icon-warn-tip",
    //         offset: 470,
    //         onClose: function () {
    //         },
    //       });
    //     }
    //   });
    // },
    initCharts() {
      // 初始化左边栏图表
      this.leftTop = echarts.init(document.getElementById('leftTopChart'));
      this.drawCharts();
    },
    drawCharts() {
      this.setChartOptions(this.leftTop, this.getFlightStatisticsOptions());
    },
    setChartOptions(chart, options) {
      chart.setOption(options);
    },
    getFlightStatisticsOptions() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          data: ['准时到达率(%)'],
          textStyle: {
            color: '#ececec',
          },
          itemStyle: {
            color: '#FFB149', // 设置图例图标颜色
          },
          itemGap: 15,
          right: '5%',
        },
        grid: {
          left:20, // 左侧边距
          right: 20,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 10, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          data:['8月','9月','10月','11月'],
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(214, 214, 214, 0.3)', // 设置 X 轴颜色
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)'
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          {
            data:[0,100,80,95],
            name: '准时到达率(%)',
            type: 'bar',
            // data: this.leftTopData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color:  '#FFB149'}, // 0% 透明色
                  { offset: 1, color:  'rgba(255,140,77,0.00)' }, // 100% 不透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#FFB149', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '20%',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    getFlightStatistics(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/flightStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.leftTopData = oData.data.xaxis.data.map((x, index) => [x, oData.data.series.data[index]])
            resolve()
          }
        });
      });

    },
    changeDetailOpen(v) {
      this.isDetailOpen = v
    },
    // positTask(info) {
    //   if (this.infoArr.length > 0) {
    //     var foundObject = this.infoArr.find(function(item) {
    //       return item.uasID === info.uasID;
    //     });
    //     let point = {
    //       longitude: foundObject.longtitude,
    //       latitude: foundObject.latitude
    //     };
    //     this.positionPoint(point);
    //   }
    // },
    async getPageData(){
      await Promise.all([
        this.getFlightStatistics(),
      ]);
      this.initCharts()
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("YYYY-MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = ["星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"];
      this.$data.timeInfo.weekday = weeks[day];
    },
    handleResize() {
      this.leftTop.resize();
    },
    searchClick(v){
      this.queryPlan(v);
    },
    positPlane(info) {
      // if (this.infoArr.length > 0) {
      //   let foundObject = this.infoArr.find(function(item) {
      //     return item.id === info.planSerial;
      //   });
      //   if (foundObject) {
      //     let point = {
      //       longitude: foundObject.longtitude,
      //       latitude: foundObject.latitude
      //     };
      //     this.positionPoint(point);
      //   }
      // }
    },
    //起飞
    clickStart(info) {
      this.changeRunTask.forEach(v=>{
        if(v.id ===info.id){
          v.startChecked = !v.startChecked
        }
      })
      if(this.changeRunTask.find(v=>v.id===info.id).startChecked){
        this.startIds.push(info.id)
      }else {
        this.startIds = this.startIds.filter(v=>v!==info.id)
      }
      //Todo 逻辑判断
      // if(!this.startIds.includes(info.id)){
      if(true){
        let data = {
          command: 1,
          orderID: info.planSerial,
          uasID: info.uavSerial,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行起飞指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行起飞指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }else {
        this.$message.error({
          message: "飞机正在飞行中执行起飞指令失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function() {}
        });
      }
    },
    //暂停/恢复
    clickCircle(info) {
      this.changeRunTask.forEach(v=>{
        if(v.id ===info.id){
          v.changeChecked = !v.changeChecked
        }
      })
      if(this.changeRunTask.find(v=>v.id===info.id).changeChecked){
        this.changeIds.push(info.id)
      }else {
        this.changeIds = this.changeIds.filter(v=>v!==info.id)
      }
      let data = {
        command: !this.changeIds.includes(info.id)?8:11,
        orderID: info.planSerial,
        uasID: info.uavSerial,
        uasModel: info.uavModel
      };
      if(this.changeIds.includes(info.id)){
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行悬停指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行悬停指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }else {
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行恢复指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行恢复指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }

    },
    //降落
    clickDown(info) {
      this.changeRunTask.forEach(v=>{
        if(v.id ===info.id){
          v.downChecked = !v.downChecked
        }
      })
      if(this.changeRunTask.find(v=>v.id===info.id).downChecked){
        this.downIds.push(info.id)
      }else {
        this.downIds = this.downIds.filter(v=>v!==info.id)
      }
      // if(!this.startIds.includes(info.id)){
      if(true){
        let data = {
          command: 1,
          orderID: info.planSerial,
          uasID: info.uavSerial,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行降落指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行降落指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }else {
        this.$message.error({
          message: "飞机已降落执行起飞指令失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function() {}
        });
      }
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&type=2&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#dashboardLogistics {
  z-index: 3;
  width: 100%;
  height: 100%;
}
.task-item_2d {
  margin-bottom: 16px;
  cursor: pointer;
  //width: calc(100% - 14px);
}
.taskcontent_2d{
  padding: 0 10px;
  height: 100%;
  overflow: auto;
}
.contentItem68 .emptyWrap{
  width: 100%;
  height: calc(100% - 44px);
}
.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}
.executePlan:hover{
  border: 2px solid transparent !important;
  background-color: #08638B !important;
}
.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}
.prePlan:hover{
  border: 2px solid transparent !important;
  background-color: #08638B !important;
}
.common .itemDetail{
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}
.common .thirdSpan {
  min-width: 40px;
}
.common .secondSpan {
  min-width: 50px;
}
.common .firstSpan {
  min-width: 90px;
}
.task-item_2d .common {
  background: rgba(1,10,18,0.68);
  height: 44px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
}
.task-item_2d .common:hover{
  background: rgba(0,174,255,0.5);
  border: none;
}
.common .firstSpan {
  min-width: 90px;
}

.common .secondSpan {
  min-width: 50px;
}

.common .thirdSpan {
  min-width: 40px;
}
.common .itemDetail{
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}
.donePlan:hover{
  border: 2px solid transparent !important;
  background-color: #08638B !important;
}
.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}
.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}

.contentItem68 .listAll_2d{
  height: calc(100% - 84px);
  padding: 0 10px;
  //width:100%;
  overflow: auto;
  margin-top: 20px;
}

.listAll_2d .warn_2d{
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}
.listAll_2d .alarm_2d {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}
.taskSearchBox{
  margin-top: 12px;
}
.taskSearchBox >>>input{
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(0,174,255,0.5);
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
}
.taskSearchBox >>>input::placeholder{
  color: #FFFFFF;
}
.taskSearchBox  >>>.el-input__icon{
  color: #FFFFFF;
  right: 15px;
  line-height: 32px;
  cursor: pointer;

}
.taskSearchBox >>> .el-input__inner{
  color: #FFFFFF;
  border-radius:0;
  border: none;
}
.taskSearchBox >>> .el-input__inner::placeholder{
  color:white;
}

.taskSearchBox input >>>i{
  //border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}
.mapWrap{
  z-index: 2;
  position: absolute;
  top:73px;
  left:0;
  width: 100%;
  height: calc(100% - 77px)
}
.contentItem30{
  flex: 30;
  max-height: 26%;
  display: flex;
  flex-direction: column;
}
.contentItem32{
  height: 32%;
  //min-height: 100px;
  display: flex;
  flex-direction: column;
}
.headerContent{
  pointer-events:none;
  z-index: 3;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: start;
  padding: 16px 22px 0 17px;
  //position: relative;
  position: absolute;
}
@media screen and (max-width: 1920px) {
  .headerContent{
    height: 144px;
    background-image: url("../../assets/img/dashboard/header.png");
  }
  .headerMiddle{
    font-size: 62px;
    line-height: 60px;
  }
}
@media screen and (min-width: 2000px) {
  .headerContent{
    height: 240px;
    background-image: url("../../assets/img/dashboard/header_2880.png");
  }
  .headerMiddle{
    line-height: 100px;
    font-size: 100px;
  }
}
.headerLeft{
  position: absolute;
  right: 17px;
  top: 16px;
  z-index: 5;
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}
.contentWrap{
  position: absolute;
  top: 76px;
  height: calc(100% - 76px);
  width: 100%;
}
.leftContent{
  z-index: 4;
  background: rgba(1,10,18,0.68);
  height: 100%;
  //width: 20%;
  width: 340px;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.rightContent{
  background: rgba(16,10,1,0.78);
  height: 100%;
  //width: 18%;
  min-width: 310px;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.leftContent{
  top:0;
  left: px;
  z-index: 4;

}
.rightContent{
  top:0;
  right: 5px;
  z-index: 4;

}
.contentItem{
  flex: 33;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.itemTitle{
  height: 42px;
  background: url("../../assets/img/2dmap/pop_bg.png") center no-repeat;
  background-size: 100%;
  padding-left: 24px;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.itemTitleText{
  font-size: 24px;
font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
font-weight: 400;
text-align: left;
color: #ffffff;
}
.plan{
  padding: 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.one{
  display: flex;
  justify-content: space-between;
}
.planState1{
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/ren_wu_zong_shu.png);
}
.planState2{
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/dai_shen_pi.png);
}
.planState3{
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/dai_qu_huo.png);
}
.planState4{
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/bo_hui.png);
}
.num{
  width: 32px;
  height: 18px;
  font-size: 26px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  margin-top: 15px;
  margin-left: 118px;
}
.txt{
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  margin-left: 115px;
  padding-top: 20px;
}
.alarmWraper{
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
}
.alarmTitle{
  width: 412px;
  height: 40px;
  background-image: url(../../assets/img/dashboard/gao_jing_lie_biao.png);
  background-position: left;
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
}
.alarmNormal,.alarmAbnormal{
  width: 412px;
  height: 40px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}
.alarmNormal{
  border: 2px solid #7A4C2D;
}
.alarmAbnormal{
  background-image: url(../../assets/img/dashboard/gao_jing_lie_biao.png);
  border: 2px solid #FF5649;
}
.number{
  min-width: 100px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  line-height: 36px;
}
.content{
  cursor: pointer;
  width: 123px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  line-height: 36px;
  position: relative;
}
.state{
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  line-height: 36px;
  min-width: 56px;
}
.barChart{
  flex: 1;
}
.task-item_2d_realTask{
  display: flex;
  width: 100%;
  min-height: 38px;
  //line-height: 38px;
  background: #170b01;
  border-radius: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  box-sizing: border-box;
  padding-left: 5px;
}

.emptyContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 45px);
  flex: 1;
  width: 100%;
  background: #170b01;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
}
.realTask .emptyContent{
  height: 100%;
}
.planeBtns .planTobtn{
  display: flex;
  align-items: center;
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1001;
}
.planeBtns .planTobtn:not(:last-child){
  margin-right: 6px;
}
.planTobtn img{
  width: 26px;
  height: 26px;
}
.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}


.planeBtns .planTobtn:hover span {
  display: block;
}
.taskWrap{
  background: rgba(23,11,1,0.50);
  border-radius: 6px;
  padding: 8px;
  box-sizing: border-box;
  height: calc(100% - 60px);
}
*{
  user-select: none;
}
.contentItem68 {
  height: 68%;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/logistics.vue